/*
创建者 左晨(2019.07.24)
期权查看页面
*/
<template>
  <div>
    <div class="header">
      <img
        src="../../assets/images/account_logo.png"
        width="200"
      >
    </div>
    <div class="cz-con">
      <div class="inner">
        <h2>合伙人积分(配送)</h2>
        <div class="content">
          <form
            action="api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253"
            name="transferForm"
            class="alipayform"
            method="POST"
            target="_blank"
          >
            <div class="element">
              <div class="etitle">支付密码:</div>
              <div class="einput"><input
                  type="password"
                  id="WIDtotal_fee"
                  name="WIDtotal_fee"
                  value="10"
                  v-model="consumeModel"
                ></div>
              <br>
              <div class="mark">注意：请输入支付密码</div>
            </div>
            <div
              class="element"
              style="display: none"
            >
              <input
                type="text"
                id="tokenId"
                name="tokenId"
                value="798cc3d3-56b0-44b2-848a-a3d6d306f253"
              >
            </div>
            <div class="element">
              <input
                class="alisubmit"
                @click="confirm"
                type="button"
                value="确认查看"
              >
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import { consumeConfirm } from "api/user";
import { getSession } from "utils/tool";
export default {
  data() {
    return {
      consumeModel: "",
    };
  },
  created() {},
  methods: {
    confirm() {
      if (this.consumeModel === "") {
        this.$Message.warning("请输入密码！");
        return;
      }
      let place = String(this.consumeModel).indexOf(".") + 1;
      if (this.consumeModel.length > 60) {
        this.$Message.warning("密码长度超限！");
        return;
      }
      console.dir(this.consumeModel);
      const postJson = {
        loginName: getSession("userName"),
        payPassword: this.consumeModel,
        userId: "",
      };
      let data = this.$Rsa.encrypt(JSON.stringify(postJson))
      consumeConfirm(data).then((res) => {
        console.dir(res);
        if (res.resCode == 1) {
          this.$Message.success("验证正确,跳转到详情页！");
          setTimeout(() => {
            this.$router.push({
              path: "/showMyAccount",
              query: {},
            });
          }, 2000);

          return;
        }

        if (res.resCode !== 1) {
          this.$Message.warning(res.resDesc);
          return;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/showConsumeConfirm.less";
</style>



// WEBPACK FOOTER //
// showConsumeConfirm.vue?4180ca3a